import React from 'react';
import styled from 'styled-components';

const TradingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const PlaceholderCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
  text-align: center;
`;

const PlaceholderTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 16px;
`;

const PlaceholderText = styled.p`
  color: #718096;
  font-size: 16px;
  margin-bottom: 24px;
`;

const ComingSoonBadge = styled.div`
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
`;

const TradingView = () => {
  return (
    <TradingContainer>
      <PlaceholderCard>
        <PlaceholderTitle>Trading Interface</PlaceholderTitle>
        <PlaceholderText>
          Advanced trading charts, order placement, and real-time market data will be available here.
          Connect your trading APIs to enable live trading functionality.
        </PlaceholderText>
        <ComingSoonBadge>Coming Soon</ComingSoonBadge>
      </PlaceholderCard>
    </TradingContainer>
  );
};

export default TradingView;
